/**
 * Эллиптическая метрика сброса карты в центр взятки — локальный армянский, классический лобби, онлайн.
 *
 * По умолчанию полуоси чуть меньше/шире половины rect (удобнее палец). Режим `inscribedEllipse` — полуоси 0.5×
 * ширины и высоты якоря: для вертикального DOM-эллипса (`rounded-[50%]`, h>w) hit-test совпадает с фигурой.
 *
 * @module components/belot/belotTrickDropMetric
 */

/** Порог сдвига пикселей: ниже — считается «клик», выше — «тащили». */
export const BELOT_TRICK_DRAG_MOVE_PX = 6;

/** Порог «внутри» зоны сброса (ellipse metric nx²+ny²). */
export const BELOT_TRICK_DROP_THRESHOLD_OUT = 1.0;

/** Гистерезис: после входа в зону допускаем чуть больший радиус выхода. */
export const BELOT_TRICK_DROP_THRESHOLD_IN = 1.16;

/** Доля полуоси по ширине (прямоугольный якорь, классика / онлайн). */
export const BELOT_TRICK_DROP_RX_FRAC = 0.408;

/** Доля полуоси по высоте (прямоугольный якорь). */
export const BELOT_TRICK_DROP_RY_FRAC = 0.6;

const INSCRIBED_RX_FRAC = 0.5;
const INSCRIBED_RY_FRAC = 0.5;

/**
 * @param {HTMLElement|null|undefined} trickCenterEl — якорь зоны взятки (как `trickCenterRef.current`).
 * @param {number} clientX
 * @param {number} clientY
 * @param {{ inscribedEllipse?: boolean }} [options] — igra: вертикальный эллипс-якорь, полуоси = половина rect.
 * @returns {number} nx²+ny²; `Infinity` если зона недоступна.
 */
export function getTrickCenterDropMetric(trickCenterEl, clientX, clientY, options = {}) {
  const zone = trickCenterEl;
  if (!zone) return Number.POSITIVE_INFINITY;
  const r = zone.getBoundingClientRect();
  if (!r.width || !r.height) return Number.POSITIVE_INFINITY;
  const cx = r.left + r.width / 2;
  const cy = r.top + r.height / 2;
  const inscribed = Boolean(options.inscribedEllipse);
  const rx = r.width * (inscribed ? INSCRIBED_RX_FRAC : BELOT_TRICK_DROP_RX_FRAC);
  const ry = r.height * (inscribed ? INSCRIBED_RY_FRAC : BELOT_TRICK_DROP_RY_FRAC);
  const nx = (clientX - cx) / Math.max(1, rx);
  const ny = (clientY - cy) / Math.max(1, ry);
  return nx * nx + ny * ny;
}
